"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _echarts = _interopRequireDefault(require("echarts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  props: {
    styles: {
      type: Object,
      default: null
    },
    optionData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      myChart: null
    };
  },
  watch: {
    optionData: {
      handler: function handler() {
        this.handleSetVisitChart();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    var vm = this;
    vm.$nextTick(function () {
      vm.handleSetVisitChart();
      window.addEventListener('resize', _this.wsFunc);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.wsFunc);
    if (!this.myChart) {
      return;
    }
    this.myChart.dispose();
    this.myChart = null;
  },
  methods: {
    wsFunc: function wsFunc() {
      if (this.myChart) this.myChart.resize();
    },
    handleSetVisitChart: function handleSetVisitChart() {
      var _this2 = this;
      var el = this.$refs.chartEl;
      if (!el) return;
      if (!this.myChart) {
        this.myChart = _echarts.default.init(el);
      }
      this.myChart.setOption(this.optionData || {}, true);
      this.$nextTick(function () {
        if (_this2.myChart) _this2.myChart.resize();
      });
    }
  }
};